import { render, staticRenderFns } from "./ContentSlider.vue?vue&type=template&id=23e8937c"
import script from "./ContentSlider.vue?vue&type=script&lang=js"
export * from "./ContentSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports